'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'thumbs-up';
var width = 512;
var height = 512;
var aliases = [128077,61575];
var unicode = 'f164';
var svgPathData = ['M144 200.4c4.1-8.1 8.1-16.3 12.2-24.4l3 0 23.7-53.4C204.2 80 218.5 51.4 225.7 37l57.2 28.6c-35.2 70.5-56.3 112.6-63.1 126.3l212.2 0 0 64-16 0 0 64-16 0 0 64-16 0 0 48-153.2 0c-2.6-1.6-5.2-3.3-7.8-4.9l-64-40-15-9.4 0-177.3z', 'M225.7-16.6l100.2 50.1 21.4 10.8-49.9 99.8 182.6 0 0 160-16 0 0 64-16 0 0 64-16 0 0 48-214.9 0-5.8-3.6-13.6-8.5 0 0-53.6-33.5 0 45.7-144 0 0-336 118.6 0 49.9-99.8 0 0c19.1-38.2 31-62 35.8-71.5l21.5 10.7zM48 432l48 0 0-240-48 0 0 240zM211.4 65.7l0 0-67.3 134.8 0 177.3 15 9.4 64 40 0 0 7.8 4.9 153.2 0 0-48 16 0 0-64 16 0 0-64 16 0 0-64-212.2 0c6.8-13.7 27.9-55.8 63.1-126.3L225.7 37 211.4 65.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;